module.exports = __webpack_public_path__ + "img/icon_tip_arrow.677c800b.svg";